// Helper functions for URL-safe Base64 encoding and decoding
const toUrlSafeBase64 = (base64) => base64.replace(/\+/g, '-').replace(/\//g, '_');
const fromUrlSafeBase64 = (urlSafeBase64) =>
  urlSafeBase64.replace(/-/g, '+').replace(/_/g, '/');

// Convert inputs to ArrayBuffer
const decoder = new TextDecoder();
const encoder = new TextEncoder();
const keyBuffer = encoder.encode(process.env.REACT_APP_MASTER_KEY);
const ivBuffer = encoder.encode(process.env.REACT_APP_MASTER_IV);

// Import key for AES-GCM
const cryptoKey = await window.crypto.subtle.importKey(
  "raw", // Key format
  keyBuffer, // Key data
  { name: "AES-GCM" }, // Algorithm
  false, // Extractable (shouldn't be exportable for security)
  ["encrypt", "decrypt"] // Usages
);

// Encryption function
export const Encrypt = async (plaintext) => {
  try {
    // Perform encryption
    const encryptedBuffer = await window.crypto.subtle.encrypt(
      { name: "AES-GCM", iv: ivBuffer }, // Algorithm with IV
      cryptoKey, // Crypto key
      encoder.encode(plaintext) // Data to encrypt
    );

    // Convert encrypted data to Base64, then to URL-safe Base64, and return the result
    const base64 = btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
    return toUrlSafeBase64(base64);
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error("Encryption failed");
  }
};

// Decryption function
export const Decrypt = async (cipherText) => {
  try {
    // Decode URL-safe Base64 to regular Base64, then to ArrayBuffer
    const base64 = fromUrlSafeBase64(cipherText);
    const encryptedBuffer = Uint8Array.from(atob(base64), (char) =>
      char.charCodeAt(0)
    );

    // Perform decryption
    const decryptedBuffer = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv: ivBuffer }, // Algorithm with IV
      cryptoKey, // Crypto key
      encryptedBuffer // Encrypted data
    );

    // Convert decrypted data to string and return the result
    return decoder.decode(decryptedBuffer);
  } catch (error) {
    console.error("Decryption error:", error);
    throw new Error("Decryption failed");
  }
};